import { MAIN_ROUTES_CONFIG, useGet2ndLevelPageUrl } from 'app-level/navigation';
import { useParams } from 'react-router-dom';
import { getStringAsKeyOf } from 'utils/typeUtils';

import { SUB_HEADER_CONFIGS } from './headers.config';
import { SubHeaderMenuItem } from '../SubHeaderMenuItem/SubHeaderMenuItem';
import { useFeatureFlag } from 'context/FeatureFlagContext';

export function SubHeader() {
  const getUrl = useGet2ndLevelPageUrl();
  const isRemittanceEnabled = useFeatureFlag('remittance');
  const { mainSegment } = useParams();
  if (!mainSegment) return null;

  const mainRouteKey = getStringAsKeyOf(MAIN_ROUTES_CONFIG, mainSegment.toLowerCase());
  if (!mainRouteKey) return null;

  const subHeadersConfig =
    mainRouteKey === 'portfolio' && isRemittanceEnabled
      ? [
          ...SUB_HEADER_CONFIGS[mainRouteKey],
          {
            routeKey: 'remittance',
            label: 'Remittance',
            iconName: 'remittance',
          },
        ]
      : SUB_HEADER_CONFIGS[mainRouteKey];

  return (
    <>
      <div className="h-full min-h-[40px] border-t border-slate-500 bg-background-surface [grid-area:header-sub-spacer] light:border-slate-100 light:bg-white" />
      <div className="flex min-h-[40px] min-h-[50px] border-t border-slate-500 bg-background-surface [grid-area:header-sub] light:border-slate-100 light:bg-white light:text-gray-600">
        {subHeadersConfig.map((config) => (
          <SubHeaderMenuItem
            key={config.routeKey}
            headerConfig={config}
            to={config.routeKey ? getUrl(mainRouteKey, config.routeKey) : ''}
          />
        ))}
      </div>
    </>
  );
}
